export const menuItems = [
  "Features",
  "Integrations",
  "Changelog",
  "Roadmap",
];

export const menuItems2 = [
  "About Us",
  "Community",
  "Careers",
  "Affiliate Program",
];
export const menuItems3 = [
  "Setting & Privacy",
  "FAQs",
  "Contact Us",
];
